/**
 * Class Resources
 * @author Fer Catalano
 */

class Resources {

    constructor() {
        // resources
        this.resources = [
            {
                id: 1,
                title: 'Cook-along videos',
                content: 'Follow along step-by-step to make your kit with a professional baker.'
            },
            {
                id: 2,
                title: 'Shopping lists',
                content: 'Grab everything you need ahead of time so you don’t miss a beat.'
            },
            {
                id: 3,
                title: 'Homeschool lessons',
                content: 'Explore the exciting theme of your kit with a fun & unique STEAM activity!'
            },
            {
                id: 4,
                title: 'Wooden Spoon 3',
                content: 'Follow along to learn how level up your baking skills with every kit.' //test d
            }
        ];

        if (window.location.href.split('/')[3] === "resources" ||
            window.location.href.split('/')[4] === "resources") {
            // process
            this.tabs();
            this.select2Init();
            this.select2Change();
            this.checkUserLogin();
            this.closeModal();
            this.clearFilter();
        }

    }

    tabs() {
        let tabs = document.querySelectorAll('.hero-resources__item');

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const tabId = tab.getAttribute('data-id');
                const tabResources = this.resources[tabId - 1];
                const tabTitle = tabResources.title;

                const title = document.querySelector('.filter-resources__title');
                title.innerHTML = tabTitle;
                const subtitle = document.querySelector('.filter-resources__subtitle');
                subtitle.innerHTML = tabResources.content;

                tabs.forEach((tab) => {
                    tab.classList.remove('active');
                });

                tab.classList.add('active');

                // get resources (ajax)
                this.getResources(tabId);
            });
        });
    }

    checkUserLogin() {
        const form = document.querySelector('#send-message-button');
        if (form) {
            form.addEventListener('click', (e) => {
                console.log('clicked');
                let email = document.querySelector('#kla_email_klaviyo_emailsignup_widget--resources').value;
                if (email && Resources.prototype.validateEmail(email)) {
                    console.log('passed');
                    Resources.prototype.setDataUser(email);
                }
            });
        }
    }

    getResources(tabId) {
        let result = document.querySelector('#js-resources-body');
        let type = document.querySelector('.hero-resources__item.active').attributes['data-type'].value;
        var formData = new FormData();
        formData.append('action', 'get_baketivity_resources');
        formData.append('tabId', tabId);
        formData.append('type', type);
    
        jQuery.ajax({
            cache: false,
            url: ajax.url,
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            beforeSend: function () {
                jQuery('#js-shop-filter-loader').show().html('<div class="grid-shop__loader"><span></span></div>');
                result.innerHTML = '';
            },
            success: function (response) {
                console.log(response);
                // hide loader and clear html
                jQuery('#js-shop-filter-loader').hide().html('');

                // No resources
                if (response.data.html.length == 0) {
                    result.innerHTML = '<p>No resources found</p>';
                    return;
                }

                // There are resources
                result.innerHTML = response.data.html;

                // Select2 - Dropdowns - Update
                Resources.prototype.select2populate(response.data.json);
            },
            complete: function () {
                Resources.prototype.select2Change();
            },
            error: function () {
                jQuery('#js-shop-filter-loader').hide().html('');
                result.innerHTML = '<p>Something went wrong</p>';
            }
        });
    }

    setDataUser(email) {
        var formData = new FormData();
        formData.append('action', 'set_baketivity_user');
        formData.append('email', email);
        jQuery.ajax({
            cache: false,
            url: ajax.url,
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function (response) {
                if (response.data) {
                    window.location.hash = '';
                    window.location.reload();
                }
            }
        });
    }

    closeModal() {
        const modal = document.querySelector('#resources-modal');
        if (!modal) return;

        const closeBtn = modal.querySelector('.modal__close');
        if (!closeBtn) return;

        closeBtn.addEventListener('click', () => {
            window.location.hash = '';
        });
    }

    select2Init() {
        // Select2 - Dropdowns 
        jQuery('.js-resources-select').select2({
            placeholder: "Select a kit"
        });
    }

    select2populate(items) {
        // clear dropdown
        jQuery('.js-resources-select').empty();
        jQuery('.js-resources-select').val(null).trigger('change');

        // add new option
        var newOption = new Option('All', '0', false, false);
        jQuery('.js-resources-select').append(newOption).trigger('change');

        // add new options
        let data = {};
        items.forEach(function (item) {
            data.id = item.id;
            data.text = item.title;
            var newOption = new Option(data.text, data.id, false, false);
            jQuery('.js-resources-select').append(newOption).trigger('change');
        });
    }

    select2Change() {
        jQuery('.js-resources-select').on('change', (e) => {
            let id = e.target.value;

            // show all cards
            if (id == 0 || id == 'all') {
                const cards = document.querySelectorAll('.filter-resources__card');
                cards.forEach((card) => {
                    card.classList.remove('d-none');
                });
                return;
            }

            // hide other cards
            const cards = document.querySelectorAll('.filter-resources__card');
            cards.forEach((card) => {
                if (card.getAttribute('id') == id) {
                    card.classList.remove('d-none');
                } else {
                    card.classList.add('d-none');
                }
            });
        });
    }

    clearFilter() {
        const cta = document.querySelector('.filter-resources__cta');

        cta.addEventListener('click', (e) => {
            e.preventDefault();
            const cards = document.querySelectorAll('.filter-resources__card');
            cards.forEach((card) => {
                card.classList.remove('d-none');
            });
        });
    }

    validateEmail(input) {
        var re = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

        if (!re.test(input)) return false;
        return true;
    }

}

window.addEventListener('DOMContentLoaded', () => new Resources());